import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { Container, Stack } from '@fiverr-private/layout_components';
import { VettedProBadge } from '@fiverr-private/badges';
import * as styles from './styles.ve.css';

interface SellerBadgeProps {
  name: string;
  domain: string;
}

const SellerBadge: React.FC<SellerBadgeProps> = ({ name, domain }) => (
  <Stack
    direction="column"
    position="absolute"
    bottom="0px"
    left="0px"
    gap="1"
    padding={{ default: '2.5', sm: '3', lg: '4', xl: '5' }}
    className={styles.sellerBadge}
    data-seller-badge
  >
    <Stack direction="row" gap="1" data-seller-badge alignItems="center">
      <Typography
        size={{ default: 'b_sm', sm: 'b_xl', lg: 'b_lg', xl: 'b_xl' }}
        fontWeight="semibold"
        color="white"
        className={styles.sellerBadgeTopLineName}
      >
        {name}
      </Typography>
      <Container
        borderStyle="solid"
        borderColor="white"
        borderWidth="sm"
        borderRadius="sm"
        width="fit-content"
        height="fit-content"
        position="relative"
        zIndex="2"
        className={styles.sellerBadgePro}
      >
        <VettedProBadge theme="dark" />
      </Container>
    </Stack>
    <Typography size={{ sm: 'b_xs', md: 'b_sm', lg: 'b_xs' }} color="white" className={styles.sellerBadgeBottomLine}>
      {domain}
    </Typography>
  </Stack>
);
export default SellerBadge;
